<template>
    <div>
        <template>
            <v-row>
                <v-col cols="12" sm="2" class="pt-0 mt-2">
                    <v-select 
                    v-model="selStream"
                    :items="streamList"
                    outlined
                    dense
                    @input="fetchData"
                    style="width: 200px;"
                    :label="$store.getters.t('스트림명 선택')"
                    /> 
                </v-col>
                <v-col class="text-right mt-2">
                    <v-btn-toggle v-model="unitType" class="mr-3">
                        <TextButton buttonText="BYTE" small value="BYTE" />
                        <TextButton buttonText="MB" small value="MB" />
                        <TextButton buttonText="GB" small value="GB" />
                    </v-btn-toggle>

                    <v-btn-toggle v-model="timeRange">
                        <TextButton :buttonText="$store.getters.t('Last 1DAY')" small value="day" />
                        <TextButton :buttonText="$store.getters.t('Last 1WEEK')" small value="week" />
                        <TextButton :buttonText="$store.getters.t('Last 1MONTH')" small value="month" />
                        <TextButton :buttonText="$store.getters.t('Last 1YEAR')" small value="year" />
                    </v-btn-toggle>

                    <IconButton icon="mdi-download" small class="ml-3" @click="downloadCSV" />
                </v-col>
            </v-row>
        </template>

        <v-row>
            <v-col>
                <WebRTCTraffic :trafficData="trafficData" :unitType="unitType" :average="average"/>
            </v-col>
        </v-row>
<!-- 
        <v-row>
            <v-col cols="12" sm="6" class="pt-0 pl-0">
                <LiveBandwidth :bandwidthData="bandwidthData" />
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pl-0 pr-0">
                <LiveFlux :trafficData="trafficData" />
            </v-col>
        </v-row> -->


    </div>
</template>

<script>
import WebRTCTraffic from '@/components/statistics/webrtcstatistics/WebRTCTraffic.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import WebRtcStreamApi from '@/api/webrtc/WebRtcStreamApi';

export default {
    components: {
        TextButton,
        IconButton,
        WebRTCTraffic
    },
    data() {
        return {
            // startDate: null,
            // endDate: null,
            // today: this.getDateString(new Date()),
            // startDateText: '',
            // endDateText: '',
            // showStartDatePicker: false,
            // showEndDatePicker: false,
            unitType: 'GB',
            timeRange: 'day',
            // bandwidthData: [],
            trafficData: [],
            selStream: 'All',
            streamList: [],
            average: {
                value: 0,
                max: 0,
                total: 0,
            },
        };
    },
    computed: {
        // finalStartDate() {
        //     return this.startDate || this.today;
        // },
        // finalEndDate() {
        //     return this.endDate || this.today;
        // }
    },
    watch: {
        // startDate(newValue) {
        //     this.startDateText = newValue;
        // },
        // endDate(newValue) {
        //     this.endDateText = newValue;
        // },
        unitType(newValue) {
            // this.unitType = newValue;
            // this.trafficData = [];
            if(this.selStream == 'All'){
                this.updateTraffic();
            } else {
                this.fetchData();
            }
        },
        timeRange(newValue) {
            // this.timeRange = newValue;
            // this.trafficData = [];
            if(this.selStream == 'All'){
                this.updateTraffic();
            } else {
                this.fetchData();
            }
        },
        selStream(newValue){
            // this.selStream = newValue;
            this.trafficData = [];
            if(this.selStream == 'All'){
                this.updateTraffic();
            } else {
                this.fetchData();
            }
        }
    },
    mounted() {
        this.setDefaultDates();
        this.fetchStreamList();
    },
    methods: {
        async fetchStreamList(){
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const params = {
                ip: frontUrl,
            }
            try {
                const response = await WebRtcStreamApi.streamListApi(params);
                if(response.status == 1){
                    this.streamList = response.data;
                    this.streamList.unshift("All");
                }
            } catch (error) {
                console.log("err : ", error)
            }
        },
        updateTraffic() {
            this.fetchDataRange();
        },
        setTimeRange(range){
            this.timeRange = range;
            this.updateTraffic();
        },
        setDefaultDates() {
            this.setTimeRange('day');
        },
        async fetchData(){
            const params = {
                stream_name: this.selStream,
                time: this.timeRange,
                size: this.unitType,
            }
            try {
                const responses = await WebRtcStreamApi.statStreamApi(params);
                this.trafficData = responses.hits.hits ?? [];

                let totalTraffic = 0;
                let maxTraffic = 0;

                const val = this.trafficData.map(e => Number(e._source.out_byte)); 

                totalTraffic += val.reduce((acc, cur) => acc + cur, 0);
                maxTraffic = Math.max(maxTraffic, ...val);

                const tmp = totalTraffic / this.trafficData.length;
                this.average.value = isNaN(tmp) ? 0 : Math.floor(tmp);
                this.average.max = Math.floor(maxTraffic);
                this.average.total = Math.floor(totalTraffic);
            } catch (error) {
                console.log("err : ", error)
            }
        },
        async fetchDataRange(){
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const params = {
                time: this.timeRange,
                size: this.unitType,
                ip: frontUrl
            }
            try {
                const responses = await WebRtcStreamApi.statApi(params);
                this.trafficData = responses.hits.hits;

                let totalTraffic = 0;
                let maxTraffic = 0;

                const val = this.trafficData.map(e => Number(e._source.out_byte)); 

                // console.log("val => ", val)

                totalTraffic += val.reduce((acc, cur) => acc + cur, 0);
                maxTraffic = Math.max(maxTraffic, ...val);

                // console.log("totalTraffic => ", totalTraffic)
                // console.log("maxTraffic => ", maxTraffic)

                this.average.value = Math.floor(totalTraffic / this.trafficData.length);
                this.average.max = Math.floor(maxTraffic);
                this.average.total = Math.floor(totalTraffic);

                // console.log("avg => ", this.average)
            } catch (error) {
                console.log("err : ", error)
            }
        },
        convertToCSV(data) {
            const array = [Object.keys(data[0])].concat(data);

            return array.map(row => {
                return Object.values(row).map(value => {
                    return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
                }).join(',');
            }).join('\n');
        },
        downloadCSV() {
            if(this.trafficData){
                let csvContent = "";

                const combinedData = [
                    ...this.customData(this.trafficData)
                ];

                csvContent += this.convertToCSV(combinedData);

                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");

                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", `LiveStatistics_${this.unitType}.csv`);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        customData(data) {
            return data.map(item => ({
                Streamid: item._source.streamid,
                Time: this.formatUnixTimestamp(item._source.probe_date),
                Value: item._source.out_byte,
                // unit: this.unitType
            }))
        },
        formatUnixTimestamp(unixTimestamp) {
            const date = new Date(unixTimestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    },
}
</script>

<style scoped>
.datepicker {
    position: absolute;
    z-index: 22;
}
</style>